// extracted by mini-css-extract-plugin
module.exports = {"MeOurTeam":"me-our-team_MeOurTeam__1BWAW","grid":"me-our-team_grid__1vElI"};